//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { CampaignsStateFactory } from '@campaigns/routes/stateFactory';

import {
  componentNameToTemplate,
  hasFeature,
} from 'app/initialization/routing/stateHelpers';

export const ambassadorStates = {
  'campaigns.ambassadors-community': CampaignsStateFactory({
    data: {
      hasAccess: () => hasFeature(FeatureNames.VibeAmbassadors),
      title: 'Campaigns: Ambassadors Community',
    },
    url: '/ambassadors/community',
    views: {
      main: {
        template: componentNameToTemplate('ambassadorsCommunityPage'),
      },
    },
  }),

  'campaigns.ambassadors-invites': CampaignsStateFactory({
    data: {
      // TODO: PD-319614 - Remove feature check once AmbassadorsInviteLinks is released
      hasAccess: () =>
        hasFeature(FeatureNames.VibeAmbassadors) &&
        hasFeature(FeatureNames.AmbassadorsInviteLinks),
      title: 'Campaigns: Ambassadors Invites',
    },
    url: '/ambassadors/invites',
    views: {
      main: {
        template: componentNameToTemplate('ambassadorsCommunityPage'),
      },
    },
  }),
};
